export var AnimatorUpdateMode;
(function (AnimatorUpdateMode) {
    AnimatorUpdateMode[AnimatorUpdateMode["Normal"] = 0] = "Normal";
    AnimatorUpdateMode[AnimatorUpdateMode["LowFrame"] = 1] = "LowFrame";
    AnimatorUpdateMode[AnimatorUpdateMode["UnScaleTime"] = 2] = "UnScaleTime";
})(AnimatorUpdateMode || (AnimatorUpdateMode = {}));
